import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { MmTranslateService } from 'mm-web-core/i18n';
import { mmIconConstants } from "../../mm-icon-constants"
import { mmI18nKeys } from '../../icon-i18n-keys'

@Component({
  selector: 'mm-delete-icon',
  templateUrl: './delete-icon.component.html',
  styleUrls: ['./delete-icon.component.scss']
})
export class DeleteIconComponent implements OnInit {

  constructor(private translateService: MmTranslateService) { }

  ngOnInit(): void {
  }

  @Output()
  confirm = new EventEmitter();
 

  i18nKeys = mmI18nKeys;
  translate(key: string) {
    return this.translateService.get(`${mmIconConstants.translationGroup}.${key}`);
  }


}
